import Header from './components/Header';
import Hero from './components/Hero';
import Carousel from './components/Carousel';
import Updates from './components/Updates';
import Cards from './components/Cards';
import IndexSection from './components/IndexSection';
import FAQ from './components/FAQ';
import Features from './components/Features';
import About from './components/About';
import Contact from './components/Contact';
import Comments from './components/Comments';
import Ranking from './components/Ranking';
import Media from './components/Media';
import AppSection from './components/AppSection';
import Topics from './components/Topics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Carousel />
        <Updates />
        <Cards />
        <IndexSection />
        <FAQ />
        <Features />
        <About />
        <Contact />
        <Comments />
        <Ranking />
        <Media />
        <AppSection />
        <Topics />
      </main>
      <Footer />
    </>
  );
}